module.exports = __webpack_public_path__ + "static/CopCar-1300680890a68a93c4e5426977dee018.mp4";